import TriangleDividerVertical from "../../components/triangle/triangle-divider-vertical"
import useMediaQueries from '../../hooks/useMediaQueries'
import authInfinite from "../../assets/icons/auth-infinite.svg"
import BrandLogo from "../../components/brand-logo";
// import { useLayoutEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { userLogin } from "../../assets/api/userActions";
import './index.scss'
import { useEffect } from "react";

const UserLogin = () => {
    const [loginPhone, setLoginPhone] = useState("");
    const [loginPassword, setLoginPassword] = useState("");

    const { isAbove922 } = useMediaQueries();

    const params = useParams();
    const navigate = useNavigate()


    useEffect(()=>{
        let ls = localStorage.getItem("userToken");
        if(ls){
            navigate("/quiz/join/"+params.code)
        }
    },[])

    const onSubmitHandler = async (e) => {
        e.preventDefault();
        const userData = await userLogin({
            phone: loginPhone,
            password: loginPassword
        });
        var regex = new RegExp('^(\\+98|0)?9\\d{9}$');
        
        if (loginPhone.length !== 11 && loginPhone.length !== 0) {
            Swal.fire({
                icon: "error",
                title: "شماره وارد شده صحیح نمیباشد",
                confirmButtonText: "باشه"

            })
        }
        else if (!loginPhone.length) {
            Swal.fire({
                icon: "error",
                title: "شماره خود را وارد کنید",
                confirmButtonText: "باشه"
            })
        }
        else if (!regex.test(loginPhone.toString())) {
            Swal.fire({
                icon: "error",
                title: "فرمت شماره وارد شده صحیح نمیباشد",
                confirmButtonText: "باشه"

            })
        }
        
        else if (userData.customCode) {
            Swal.fire({
                icon: "error",
                title: `${userData.error}`,
            })
        }
        else {
            const today = new Date()
            let tomorrow = new Date()
            const setExpireDate = tomorrow.setDate(today.getDate() + 1)
            const { quizToken, ...newUserData } = userData;
            // console.log(userData);
            localStorage.setItem("userToken", JSON.stringify({
                ...newUserData, quizToken: quizToken, "expireDate": setExpireDate
            }))
            navigate("/quiz/join/"+params.code)
        }

    }

    function renderSvgBox() {
        if (isAbove922) {
            return (
                <div className="auth-page__svg-box">
                    <object
                        type="image/svg+xml"
                        data={authInfinite}
                        width="523"
                        height="308"
                    >
                        عکس متحرک
                    </object>
                    <BrandLogo width="128" height="39" className="auth-page__brand-logo" />
                </div>
            );
        }
    }

    return (
        <main className="auth-page">
            {renderSvgBox()}
            <section className="auth-page__content">
                <TriangleDividerVertical />
                <div className="auth-page__form-container">
                    <div className="auth-page--center">
                        
                        <form
                            onSubmit={onSubmitHandler}
                            className="form-login"
                        >
                            <h4 className="login-title">ورود</h4>
                            <p className="login-description">لطفا وارد حساب کاربری خود شوید</p>
                            <input
                                type="number"
                                className="input-style"
                                placeholder="شماره تلفن همراه"
                                onChange={(e) => {
                                    setLoginPhone(e.target.value);
                                }}
                            />
                            <input
                                type="password"
                                className="input-style"
                                placeholder="رمز عبور"
                                onChange={(e) => {
                                    setLoginPassword(e.target.value);
                                }}
                            />
                            <Link to="/auth/forget-password" className="link-login">
                                فراموشی رمز عبور
                            </Link>
                            <button
                                type="submit"
                                className="button-login"
                            >
                                ورود
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default UserLogin